import dayjs from "dayjs";

export const maskPhone = (value: string ) => {
  const cleaned = (`${value}`).replaceAll(/\D/g, "");
  const match = cleaned.match(/^(1)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return "";

};

export const dateFormatter = (value: string ) => dayjs(value).format('MM/DD/YYYY');

export const dateUpdateFormatter = (value: any ) => dayjs(value).format('YYYY-MM-DD');

export const dateTimeFormatter = (value: string ) => dayjs(value).format('MM/DD/YYYY hh:mm A');

export const birthDateFormatter = (value: string ) => dayjs(value).format('MMM DD').split(',')[0];


export const dateValueFormatter = (value: any ) => {
  if (dayjs(value,'YYYY-MM-DD', true ).isValid()) {
    return dayjs(value).format('MM/DD/YYYY')
  } 
  return value
  
};


export const cardExpirationFormatter = (value: string ) => dayjs(value).format('MM/YYYY');

export const capitilizeFormatter = (value: string ) => value.charAt(0).toUpperCase()
  + value.slice(1);


